import { createRouter, createWebHashHistory } from 'vue-router'

// import HomeNotLogin from '../views/HomeNotLogin.vue'
import Home from '../views/Home.vue'
import Login from '../components/Login.vue'
import MBranchs from '../components/MBranchs.vue'
import MTests from '../components/MTests.vue'
import MTestsuits from '../components/MTestsuits.vue'
import MPropack from '../components/MPropack.vue'
import MClinics from '../components/MClinics.vue'
import MClinicsRemote from '../components/MClinicsRemote.vue'
import MSpecimens from '../components/MSpecimens.vue'
import MRoom from '../components/MRoom.vue'
import MPatients from '../components/MPatients.vue'
import MPayments from '../components/MPayments.vue'
import MRemarks from '../components/MRemarks.vue'

import LabCreate from '../components/LabCreate.vue'
import LabCoverSheet from '../components/LabCoverSheet.vue'
import LabReceive from '../components/LabReceive.vue'
import LabWorkSheet from '../components/LabWorkSheet.vue'
import LabResult from '../components/LabResult.vue'
import LabApprove from '../components/LabApprove.vue'
import LabPrint from '../components/LabPrint.vue'
import LabRelease from '../components/LabRelease.vue'
import RepDshSummary from '../components/RepDshSummary.vue'

import LabPaidCash from '../components/LabPaid.vue'
import LabPaidCredit from '../components/LabPaidCredit.vue'
import LabStatus from '../components/LabStatus.vue'
import RcptCreate from '../components/RcptCreate.vue'
import RepSumTestsuit from '../components/RepSumTestsuit.vue'
import RepLastLabOfPat from '../components/RepLastLabOfPat.vue'
import RepPatSummary from '../components/RepPatSummary.vue'

import RepLabStatus from '../components/RepLabStatus.vue'
import RBillNote from '../components/RBillNote.vue'
import Setting from '../components/Setting.vue'
import Setting2 from '../components/Setting2.vue'
import UserChgpwd from '../components/UserChgpwd.vue'

const routes = [
  {
    path: '/',
    name: 'HomeNotLogin',
    component: Home
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/MBranchs',
    name: 'MBranchs',
    component: MBranchs
  },
  {
    path: '/MTests',
    name: 'MTests',
    component: MTests
  },
  {
    path: '/MClinics',
    name: 'MClinics',
    component: MClinics
  },
  {
    path: '/MClinicsRemote',
    name: 'MClinicsRemote',
    component: MClinicsRemote
  },
  {
    path: '/MTestsuits',
    name: 'MTestsuits',
    component: MTestsuits
  },
  {
    path: '/MPropack',
    name: 'MPropack',
    component: MPropack
  },
  {
    path: '/MSpecimens',
    name: 'MSpecimens',
    component: MSpecimens
  },
  {
    path: '/MRoom',
    name: 'MRoom',
    component: MRoom
  },
  {
    path: '/MPatients',
    name: 'MPatients',
    component: MPatients
  },
  {
    path: '/MPayments',
    name: 'MPayments',
    component: MPayments
  },
  {
    path: '/MRemarks',
    name: 'MRemarks',
    component: MRemarks
  },
  {
    path: '/LabCreate',
    name: 'LabCreate',
    component: LabCreate
  },
  {
    path: '/LabCoverSheet',
    name: 'LabCoverSheet',
    component: LabCoverSheet
  },
  {
    path: '/LabReceive',
    name: 'LabReceive',
    component: LabReceive
  },
  {
    path: '/LabWorkSheet',
    name: 'LabWorkSheet',
    component: LabWorkSheet
  },
  {
    path: '/LabResult',
    name: 'LabResult',
    component: LabResult
  },
  {
    path: '/LabApprove',
    name: 'LabApprove',
    component: LabApprove
  },
  {
    path: '/LabPrint',
    name: 'LabPrint',
    component: LabPrint
  },
  {
    path: '/LabRelease',
    name: 'LabRelease',
    component: LabRelease
  },
  {
    path: '/RepDshSummary',
    name: 'RepDshSummary',
    component: RepDshSummary
  },
  {
    path: '/LabPaidCash',
    name: 'LabPaidCash',
    component: LabPaidCash
  },
  {
    path: '/LabPaidCredit',
    name: 'LabPaidCredit',
    component: LabPaidCredit
  },
  {
    path: '/LabStatus',
    name: 'LabStatus',
    component: LabStatus
  },
  {
    path: '/RcptCreate',
    name: 'RcptCreate',
    component: RcptCreate
  },
  {
    path: '/RepLabStatus',
    name: 'RepLabStatus',
    component: RepLabStatus
  },
  {
    path: '/RepSumTestsuit',
    name: 'RepSumTestsuit',
    component: RepSumTestsuit
  },
  {
    path: '/RepLastLabOfPat',
    name: 'RepLastLabOfPat',
    component: RepLastLabOfPat
  },
  {
    path: '/RepPatSummary',
    name: 'RepPatSummary',
    component: RepPatSummary
  },
  {
    path: '/RBillNote',
    name: 'RBillNote',
    component: RBillNote
  },
  {
    path: '/Setting',
    name: 'Setting',
    component: Setting
  },
  {
    path: '/Setting2',
    name: 'Setting2',
    component: Setting2
  },
  {
    path: '/UserChgpwd',
    name: 'UserChgpwd',
    component: UserChgpwd
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
